const footer = {
  en: {
    translation: {
      you_are: "You are",
      alt_sitemap: "restaurants in the world",
      about: {
        title: "Legal",
        about_foodiestrip: "About foodiestrip.com",
        press: "Press Office",
        investor: "Investor",
        terms_of_services: "Terms and Conditions",
        legal: "Legal",
        privacy_policy: "Privacy Policy",
        cookie_policy: "Cookie Policy",
        copy_rights1: "© ",
        copy_rights2:
          " FoodiesTrip LLC - VAT ID IT01975940675 - All Rights Reserved"
      },
      foodiestrip: {
        title: "foodiestrip",
        mobile: "foodiestrip.com mobile",
        check_in: 'The "Check-in" Project',
        blog: "Blog",
        support: "Support",
        company_data: "Company Data",
        mission: "Manifesto",
        team: "Team",
        story: "Story",
        contact_us: "Contact us",
        home_page: "Home",
        talk_about_us: "Press",
        toc: "General Terms and conditions"
      },
      blog: {
        title: "Blog",
        title_desktop: "Blog and Community",
        taste_itinerary: "Gastronomic itineraries",
        story_stories: "History and Stories",
        food_health: "Food and Health",
        guides_advices: "Tips and Guides",
        food_influencer: "Food Influencer",
        actuality: "Trending Now",
        trends: "Trends"
      },
      business: {
        title: "For restaurants",
        claim_your_page: "Claim your Business Page",
        enter_your_page: "Go to your Business Page",
        suggested: "Suggest your Business Page",
        support: "Business Support",
        blog: "Business Blog",
        our_vision: "Our Vision",
        meet_your_customers: "Meet your Customers",
        foodiestrip_for_business: "Foodiestrip for Business",
        why_foodiestrip: "Why foodiestrip",
        create_your_site: "Create your website",
        handle_page: "Manage your business page"
      },
      support: {
        title: "Support"
      },
      app: {
        title: "App",
        restaurants_guide: "Restaurants Guide"
      },
      languages: {
        title: "Languages"
      },
      download: {
        title: "Download app"
      },
      social: {
        title: "Follow us"
      },
      my_business: {
        title: "My business",
        manage_info: "Manage information",
        menu: "Menu",
        reviews: "Reviews",
        statistics: "Statistics",
        customers_activities: "Customers activities"
      },
      europe: {
        title: "Around the world",
        title_italy: "Italy",
        rome: "Rome Restaurants",
        venice: "Venice Restaurants",
        milan: "Milan Restaurants",
        florence: "Florence Restaurants",
        naples: "Naples Restaurants",
        paris: "Paris Restaurants",
        nice: "Nice Restaurants",
        london: "London Restaurants",
        liverpool: "Liverpool Restaurants",
        dublin: "Dublin Restaurants",
        berlin: "Berlin Restaurants",
        munchen: "Munchen Restaurants",
        vienna: "Vienna Restaurants",
        innsbruck: "Innsbruck Restaurants",
        geneve: "Geneve Restaurants",
        cardiff: "Cardiff Restaurants",
        madrid: "Madrid Restaurants",
        barcellona: "Barcelona Restaurants",
        atene: "Athens Restaurants",
        rotterdam: "Rotterdam Restaurants",
        bologna: "Bologna Restaurants",
        turin: "Torino Restaurants",
        san_benedetto_del_tronto: "S. Benedetto del Tr. Restaurants",
        modena: "Modena Restaurants",
        avellino: "Avellino Restaurants",
        rimini: "Rimini Restaurants",
        ascoli_piceno: "Ascoli Piceno Restaurants",
        cesena: "Cesena Restaurants",
        pescara: "Pescara Restaurants",
        lecce: "Lecce Restaurants",
        cagliari: "Cagliari Restaurants",
        palermo: "Palermo Restaurants",
        civitanova_marche: "Civitanova Marche Restaurants",
        la_valletta: "La Valletta Restaurants",
        new_york: "New York Restaurants"
      },
      why_foodiestrip: {
        title: "Why foodiestrip",
        our_vision: "Our vision",
        connect_to_customers: "Connect to your customers",
        patented_checkin: "Patented check-in",
        categories_and_reviews: "Categories and Reviews",
        meet_your_customers: "Meet your customers",
        your_privacy_matters: "Your privacy matters"
      },
      certify_your_business: {
        title: "Certify your business",
        foodiestrip_for_business: "Foodiestrip for business",
        claim_your_business: "How to claim your business",
        suggest_your_business: "How to suggest your business"
      },
      business_page_guide: {
        title: "Business page guide",
        manage_page: "Manage your page",
        add_assistants: "Add assistants"
      },
      marketing_tools: {
        title: "Marketing tools",
        website: "Create your website",
        our_services: "Our services",
        experience: "Manage your photos",
        social: "Social media plan"
      },
      area_owner: {
        title: "Area owner",
        login: "Log in to your business page",
        recover_password: "Recover password",
        sign_up: "Create your business account"
      },
      store: {
        title: "Store",
        cart: "Your cart",
        products: "Our products",
        billing_activity: "Your orders"
      },
      footer_subtitle_1:
        "Foodiestrip can help you to grow and give a new visibility to your restaurant",
      footer_subtitle_2:
        "Use our reviews to facilitate and enrich the decision-making processes in your business, improving your customers' experience"
    }
  },
  it: {
    translation: {
      you_are: "Tu sei a",
      alt_sitemap: "i ristoranti nel mondo",
      about: {
        title: "Informazioni",
        about_foodiestrip: "Parlando di foodiestrip.com",
        press: "Ufficio Stampa",
        investor: "Investitore",
        terms_of_services: "Termini e Condizioni",
        legal: "Legale",
        privacy_policy: "Privacy Policy",
        cookie_policy: "Cookie Policy",
        copy_rights1: "© ",
        copy_rights2:
          " FoodiesTrip S.r.l. - P.IVA IT01975940675 - All Rights Reserved"
      },
      foodiestrip: {
        title: "foodiestrip",
        mobile: "foodiestrip.com mobile",
        check_in: 'Progetto "Check-in"',
        blog: "Blog",
        support: "Assistenza",
        company_data: "Dati societari",
        mission: "Manifesto",
        team: "Team",
        story: "Storia",
        contact_us: "Contattaci",
        home_page: "Home",
        talk_about_us: "Parlano di noi",
        toc: "Condizioni generali di contratto"
      },
      blog: {
        title: "Blog",
        title_desktop: "Blog e Community",
        taste_itinerary: "Itinerari Del Gusto",
        story_stories: "Storia e Storie",
        food_health: "Cibo e Salute",
        guides_advices: "Guide e Consigli",
        food_influencer: "Food Influencer",
        actuality: "Attualità",
        trends: "Tendenze"
      },
      business: {
        title: "Per i Ristoratori",
        claim_your_page: "Rivendica la tua Attività",
        enter_your_page: "Accedi alla tua Attività",
        suggested: "Suggerisci la tua Attività",
        support: "Assistenza Gestori",
        blog: "Business Blog",
        our_vision: "La Nostra Filosofia",
        meet_your_customers: "Incontra i Tuoi Clienti",
        foodiestrip_for_business: "Foodiestrip for Business",
        why_foodiestrip: "Perché foodiestrip",
        create_your_site: "Crea il tuo sito",
        handle_page: "Gestisci pagina"
      },
      support: {
        title: "Supporto"
      },
      app: {
        title: "App",
        restaurants_guide: "Guida Ristoranti"
      },
      languages: {
        title: "Lingue"
      },
      download: {
        title: "Scarica l'app"
      },
      social: {
        title: "Seguici"
      },
      my_business: {
        title: "La mia attività",
        manage_info: "Gestione informazioni",
        menu: "Menu",
        reviews: "Recensioni",
        statistics: "Statistiche",
        customers_activities: "Attività clienti"
      },
      europe: {
        title: "foodiestrip nel mondo",
        title_italy: "Italia",
        rome: "Ristoranti a Roma",
        venice: "Ristoranti a Venezia",
        milan: "Ristoranti a Milano",
        florence: "Ristoranti a Firenze",
        naples: "Ristoranti a Napoli",
        paris: "Ristoranti a Parigi",
        nice: "Ristoranti a Nizza",
        london: "Ristoranti a Londra",
        liverpool: "Ristoranti a Liverpool",
        dublin: "Ristoranti a Dublino",
        berlin: "Ristoranti a Berlino",
        munchen: "Ristoranti a Monaco",
        vienna: "Ristoranti a Vienna",
        innsbruck: "Ristoranti a Innsbruck",
        geneve: "Ristoranti a Ginevra",
        cardiff: "Ristoranti a Cardiff",
        madrid: "Ristoranti a Madrid",
        barcellona: "Ristoranti a Barcellona",
        atene: "Ristoranti a Atene",
        rotterdam: "Ristoranti a Rotterdam",
        bologna: "Ristoranti a Bologna",
        turin: "Ristoranti a Torino",
        san_benedetto_del_tronto: "Ristoranti a S. Benedetto del Tr.",
        modena: "Ristoranti a Modena",
        avellino: "Ristoranti a Avellino",
        rimini: "Ristoranti a Rimini",
        ascoli_piceno: "Ristoranti a Ascoli Piceno",
        cesena: "Ristoranti a Cesena",
        pescara: "Ristoranti a Pescara",
        lecce: "Ristoranti a Lecce",
        cagliari: "Ristoranti a Cagliari",
        palermo: "Ristoranti a Palermo",
        civitanova_marche: "Ristoranti a Civitanova Marche",
        la_valletta: "Ristorani a La Valletta",
        new_york: "Ristoranti a New York"
      },
      why_foodiestrip: {
        title: "Perché foodiestrip",
        our_vision: "La nostra filosofia",
        connect_to_customers: "Connettiti ai tuoi clienti",
        patented_checkin: "Check-in brevettato",
        categories_and_reviews: "Categorie e recensioni",
        meet_your_customers: "Incontra i tuoi clienti",
        your_privacy_matters: "La privacy è importante"
      },
      certify_your_business: {
        title: "Certifica la tua attività",
        foodiestrip_for_business: "Foodiestrip for business",
        claim_your_business: "Come rivendicare la tua attività",
        suggest_your_business: "Suggerisci la tua attività"
      },
      business_page_guide: {
        title: "Guida all'area riservata",
        manage_page: "Gestione pagina",
        add_assistants: "Aggiungi collaboratori"
      },
      marketing_tools: {
        title: "Strumenti marketing",
        website: "Sito web",
        our_services: "I nostri servizi",
        experience: "Gestione foto",
        social: "Piano editoriale social"
      },
      area_owner: {
        title: "Area owner",
        login: "Accedi alla tua attività",
        recover_password: "Recupero password",
        sign_up: "Crea account business"
      },
      store: {
        title: "Store",
        cart: "Il tuo carrello",
        products: "I nostri prodotti",
        billing_activity: "I tuoi ordini"
      },
      footer_subtitle_1:
        "Foodiestrip può aiutarti a crescere e a dare nuova visibilità al tuo ristorante.",
      footer_subtitle_2:
        "Utilizza le nostre recensioni per facilitare ed arricchire i processi decisionali nel tuo locale, migliorando l'esperienza dei clienti"
    }
  }
};

export default footer;



// WEBPACK FOOTER //
// ./src/Language/footer.js